import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/workbooks", label: "Workbooks" },
  { to: "/worksheets", label: "Worksheets" },
  { to: "/about", label: "About" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b-4 border-sky-100 bg-white/90 backdrop-blur">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
        <Link to="/" data-testid="nav-logo" aria-label="Divine Kids Learning home">
          <Logo className="text-lg sm:text-xl" />
        </Link>
        <div className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 font-display text-base font-bold transition-colors ${
                  isActive ? "bg-sky-100 text-brand-blue" : "text-slate-600 hover:bg-sky-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/shop"
            data-testid="nav-shop-now-button"
            className="ml-3 inline-flex items-center gap-2 rounded-full bg-brand-red px-6 py-2.5 font-display text-base font-bold text-white shadow-[0_4px_0_0_#B91C1C] transition-transform active:translate-y-1 active:shadow-none"
          >
            <ShoppingBag className="h-4 w-4" /> Shop Now
          </Link>
        </div>
        <button
          data-testid="mobile-menu-button"
          aria-label="Toggle menu"
          onClick={() => setOpen(!open)}
          className="rounded-full bg-sky-100 p-2.5 text-slate-700 lg:hidden"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>
      {open && (
        <div data-testid="mobile-nav" className="border-t-2 border-sky-100 bg-white px-4 pb-4 lg:hidden">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-xl px-4 py-3 font-display text-lg font-bold ${
                  isActive ? "bg-sky-100 text-brand-blue" : "text-slate-600"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/shop"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 rounded-full bg-brand-red px-6 py-3 font-display text-lg font-bold text-white"
          >
            <ShoppingBag className="h-5 w-5" /> Shop Now
          </Link>
        </div>
      )}
    </header>
  );
};
